module.exports = __webpack_public_path__ + "static/media/rede-protecao-2.35daec7b.jpg";